import React from "react";
import "./Footer.css"; // Import the CSS for styling

function Footer() {
  return (
    <footer className="Footer">
      <p>&copy; 2024 MyWebsite. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
